import apiClient from '@/services/axios'

export async function get(limit = 10) {
  var response = await apiClient.get('/UserPayments/latest?limit=' + limit)
  if (response) {
    return response.data
  }

  throw new Error('Unable to get latest transactions.')
} 